import React from 'react'
import styled from '@emotion/styled'
import {CarouselWidgets} from 'components/CarouselWidgets'

import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const Wrapper = styled.section`
  padding: 0 ${cssTheme.layout.spacing.s500} 0;
  ${linariaMq.desktopXs} {
    padding: ${cssTheme.layout.spacing.s700} 0 ${cssTheme.layout.spacing.s950};
  }
`

interface Props {
  hasContext?: boolean
}

export const WidgetsSection: React.FC<Props> = ({hasContext}) => {
  return (
    <Wrapper>
      <CarouselWidgets hasContext={hasContext} space="s900" />
    </Wrapper>
  )
}
